module.exports = __webpack_public_path__ + "videos/mts-main-products-chats.20ba7c1.mp4";